<template>
    <div class="add-products-to-cart">
        <div class="product-info">
            <div class="product-title is-size-4 is-size-3-desktop">
                {{ product.data.name }}
                <b-icon icon="check" v-if="quantity > 0"/>
            </div>
            <div class="product-price">
                <div class="product-price-text">{{ totalPrice | money }}</div>
                <b-icon icon="angle-right"/>
                <div class="product-price-text " :class="{'has-text-success': quantity > 0}">
                    <span v-if="quantity">{{ quantity }}</span>
                    <span v-if="product.data.priceReference > 1 && !quantity">{{ product.data.priceReference }}</span>
                    {{ product.data.measureUnit }}
                </div>
            </div>
        </div>
        <div class="cart-buttons" v-if="product.data.stock >= product.data.priceReference">
            <b-button @click="add" icon-left="plus" type="is-primary" :disabled="!canAddToCart" rounded/>
            <b-button class="remove-button" size="is-small" @click="remove" icon-left="minus" v-if="quantity > 0"
                      rounded/>
        </div>
        <b-tag rounded v-else>Indisponível</b-tag>
    </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
    name: "storeProductAdd",

    props: {
        product: {
            type: Object,
            required: true
        }
    },

    computed: {

        ...mapGetters(['productsInCart']),

        canAddToCart() {

            if (this.inCart) {
                const inStock = parseInt(this.product.data.stock);
                const nextQuantity = parseInt(this.inCart.quantity) + parseInt(this.product.data.priceReference);
                return nextQuantity <= inStock;
            }

            return true;
        },

        inCart() {

            const products = this.productsInCart;
            for (let i = 0; i < products.length; i++) {
                const cartProduct = products[i];
                if (cartProduct.id === this.product.id) {
                    return cartProduct;
                }
            }

            return null;

        },

        totalPrice() {

            if (this.inCart) {
                return this.inCart.totalPrice;
            }

            return this.product.data.price;
        },

        quantity() {

            if (this.inCart) {
                return this.inCart.quantity;
            }

            return 0;
        }
    },

    methods: {
        add() {
            this.$store.dispatch('addProductToCart', this.product);
        },

        remove() {
            this.$store.dispatch('removeProductFromCart', this.product);
        }
    }
}
</script>

<style lang="scss">

@import '@/styles/config.sass';

.add-products-to-cart {
    display: flex;
    align-items: center;

    .product-info {
        flex: 1 auto;
        padding-right: 15px;

        .product-title {
            display: flex;
            align-items: center;
            font-weight: bold;

            .icon {
                margin-left: 8px;
                font-size: 10px;
                color: $primary;
            }
        }

        .product-price {
            display: flex;
            align-items: center;

            .icon {
                font-size: 10px;
                color: #ddd;
            }
        }
    }

    .cart-buttons {
        display: flex;
        flex-direction: column;
        align-items: center;

        .remove-button {
            margin-top: .5rem;
        }
    }
}
</style>
